export function safeLoginRedirect(search) {
  const redirect = new URLSearchParams(search).get('redirect');
  if (!redirect || !redirect.startsWith('/') || redirect.startsWith('//')) {
    return '';
  }
  return redirect;
}

export function loginPathForCurrentPage() {
  const returnTo = `${window.location.pathname}${window.location.search}`;
  return `/login?redirect=${encodeURIComponent(returnTo)}`;
}
